import { render, staticRenderFns } from "./exhibition-register.vue?vue&type=template&id=10e283ce&scoped=true&"
import script from "./exhibition-register.vue?vue&type=script&lang=js&"
export * from "./exhibition-register.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-register.vue?vue&type=style&index=0&id=10e283ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e283ce",
  null
  
)

export default component.exports